/* tslint:disable */

declare var Object: any;
export interface LearningQuestionInterface {
  "sfdcId"?: string;
  "IsDeleted"?: boolean;
  "CreatedDate"?: Date;
  "CreatedById"?: string;
  "CurrencyIsoCode"?: string;
  "LastModifiedDate"?: Date;
  "LastModifiedById"?: string;
  "Name"?: string;
  "SystemModstamp"?: Date;
  "LastActivityDate"?: Date;
  "Question_Line__c"?: string;
  "Answer_Sequence__c"?: string;
  "Correct_Boolean__c"?: string;
  "Correct_Number__c"?: number;
  "Description_RTA__c"?: string;
  "Description__c"?: string;
  "Order__c"?: number;
  "Type__c"?: string;
  "Marks__c"?: number;
  "CreatedBy__c"?: string;
  "id"?: number;
  "createdAt"?: Date;
  "updatedAt"?: Date;
}

export class LearningQuestion implements LearningQuestionInterface {
  "sfdcId": string;
  "IsDeleted": boolean;
  "CreatedDate": Date;
  "CreatedById": string;
  "CurrencyIsoCode": string;
  "LastModifiedDate": Date;
  "LastModifiedById": string;
  "Name": string;
  "SystemModstamp": Date;
  "LastActivityDate": Date;
  "Question_Line__c": string;
  "Answer_Sequence__c": string;
  "Correct_Boolean__c": string;
  "Correct_Number__c": number;
  "Description_RTA__c": string;
  "Description__c": string;
  "Order__c": number;
  "Type__c": string;
  "Marks__c": number;
  "CreatedBy__c": string;
  "id": number;
  "createdAt": Date;
  "updatedAt": Date;
  constructor(data?: LearningQuestionInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `LearningQuestion`.
   */
  public static getModelName() {
    return "LearningQuestion";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of LearningQuestion for dynamic purposes.
  **/
  public static factory(data: LearningQuestionInterface): LearningQuestion{
    return new LearningQuestion(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'LearningQuestion',
      plural: 'LearningQuestions',
      path: 'LearningQuestions',
      idName: 'id',
      properties: {
        "sfdcId": {
          name: 'sfdcId',
          type: 'string'
        },
        "IsDeleted": {
          name: 'IsDeleted',
          type: 'boolean'
        },
        "CreatedDate": {
          name: 'CreatedDate',
          type: 'Date'
        },
        "CreatedById": {
          name: 'CreatedById',
          type: 'string'
        },
        "CurrencyIsoCode": {
          name: 'CurrencyIsoCode',
          type: 'string'
        },
        "LastModifiedDate": {
          name: 'LastModifiedDate',
          type: 'Date'
        },
        "LastModifiedById": {
          name: 'LastModifiedById',
          type: 'string'
        },
        "Name": {
          name: 'Name',
          type: 'string'
        },
        "SystemModstamp": {
          name: 'SystemModstamp',
          type: 'Date'
        },
        "LastActivityDate": {
          name: 'LastActivityDate',
          type: 'Date'
        },
        "Question_Line__c": {
          name: 'Question_Line__c',
          type: 'string'
        },
        "Answer_Sequence__c": {
          name: 'Answer_Sequence__c',
          type: 'string'
        },
        "Correct_Boolean__c": {
          name: 'Correct_Boolean__c',
          type: 'string'
        },
        "Correct_Number__c": {
          name: 'Correct_Number__c',
          type: 'number'
        },
        "Description_RTA__c": {
          name: 'Description_RTA__c',
          type: 'string'
        },
        "Description__c": {
          name: 'Description__c',
          type: 'string'
        },
        "Order__c": {
          name: 'Order__c',
          type: 'number'
        },
        "Type__c": {
          name: 'Type__c',
          type: 'string'
        },
        "Marks__c": {
          name: 'Marks__c',
          type: 'number'
        },
        "CreatedBy__c": {
          name: 'CreatedBy__c',
          type: 'string'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
      },
      relations: {
      }
    }
  }
}
